var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseLink',_vm._b({staticClass:"w-max"},'BaseLink',_vm.link,false),[_c('render-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }